// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".w-toolbar-search{height:inherit}.w-toolbar-search button{height:inherit!important;margin:0!important}.w-toolbar-search__form{z-index:5;position:absolute;top:0;right:0;bottom:0;left:0}.w-toolbar-search__form input{margin-top:0!important}.w-toolbar-search--mobile__form{right:0;left:0}.w-toolbar-search .v-icon{position:relative;top:2px}.w-toolbar-search .w-menu__item{margin-left:8px}", ""]);
// Exports
module.exports = exports;
